/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { ActionableNotification, Button, Link, ModalBody, ModalFooter } from '@carbon/react';

import { Modal, ModalContent } from 'App/Pages/Diagram/features/deployment/modals/modal-base';
import Header from 'App/Pages/Diagram/features/deployment/modals/deploy-modal/Header';
import { defineStagesModalStore } from 'App/Pages/Diagram/Deployment/defineStagesModal';

export default function NoStageSelected({ isOpen, mode, deploymentType, onClose }) {
  return (
    <Modal open={isOpen} preventCloseOnClickOutside>
      <Header mode={mode} deploymentType={deploymentType} onClose={onClose} />
      <ModalBody>
        <ModalContent>
          <ActionableNotification
            data-modal-primary-focus
            inline
            actionButtonLabel={'Define stages'}
            onActionButtonClick={() => {
              onClose();
              // @ts-ignore
              defineStagesModalStore.open({ executeModalMode: mode });
            }}
            kind="warning"
            lowContrast
            hideCloseButton
            title="Stages not configured"
            subtitle={
              <span>
                To deploy your process application, assign a cluster to at least one stage (Development, Testing,
                Staging or Production).{' '}
                <Link
                  href="https://docs.camunda.io/docs/next/components/modeler/web-modeler/process-applications/" /* TODO Update the learn more link: https://github.com/camunda/web-modeler/issues/10299 */
                  target="_blank"
                >
                  Learn more
                </Link>
              </span>
            }
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <Button kind="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button disabled>Deploy</Button>
      </ModalFooter>
    </Modal>
  );
}
